import type { QueryClient } from "@tanstack/react-query";

/** Refresh contact fallback and username-only membership everywhere after a phone changes. */
export function invalidateCustomerContactQueries(queryClient: QueryClient) {
  return Promise.all(
    [
      "getLead",
      "leads",
      "customers",
      "journeysOverview",
      "getComments",
      "lead-activity",
      "track",
      "getLeadSales",
      "getStagesByJourney",
    ].map((key) => queryClient.invalidateQueries({ queryKey: [key] })),
  );
}
